module.exports = __webpack_public_path__ + "img/2_155.0cae2c00.png";